export default "__VITE_ASSET__BYXQSYbC__"